import { FC, useState } from 'react';
import { Table, TableCell, TableContainer, TableFooter, TableHead } from '@mui/material';
import { PaginationWrapper } from 'screens/templates/Lists/ListWrapper/Wrapper.styled';
import DocumentTableBody from './DocumentTableBody';
import { useTranslation } from 'react-i18next';
import Pagination from 'components/Pagination/Pagination';
import { DocumentInfo } from 'api/documents';

interface DocumentTableProps {
  documents: DocumentInfo[];
  commercialRelation: string;
}

const DocumentTable: FC<DocumentTableProps> = ({ documents, commercialRelation }) => {
  const ROWS_PER_PAGE: number = 10;
  const { t } = useTranslation();
  const [page, setPage] = useState<number>(0);

  const handlePage = (page: number): void => {
    setPage(page);
  };

  return (
    <TableContainer data-testid="documents-table">
      <Table>
        <TableHead
          sx={{
            '& > *': {
              py: 1,
              pl: 3,
            },
          }}
        >
          <TableCell>{t('documents.table.header.name')}</TableCell>
          <TableCell>{t('documents.table.header.document')}</TableCell>
        </TableHead>
        {documents
          .slice(page * ROWS_PER_PAGE, page * ROWS_PER_PAGE + ROWS_PER_PAGE)
          .map((document: DocumentInfo, index: number) => (
            <DocumentTableBody
              key={page * ROWS_PER_PAGE + index}
              documentName={document.displayName}
              documentLink={document.location}
              commercialRelation={commercialRelation}
            />
          ))}
      </Table>
      <Table data-testid="documents-table-pagination">
        <TableFooter>
          <PaginationWrapper data-testid="pagination-wrapper">
            <Pagination
              page={page}
              rowsPerPage={ROWS_PER_PAGE}
              handleChangePage={(
                _: React.MouseEvent<HTMLButtonElement> | null,
                pageNumber: number
              ): void => handlePage(pageNumber)}
              count={documents.length}
            />
          </PaginationWrapper>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default DocumentTable;
